import { XCircle, Mail, Phone } from "lucide-react"

const RejectedDashboard = ({ employee }) => {
  return (
    <div className="space-y-8">
      <div className="bg-gradient-to-r from-amber-400 via-amber-300 to-amber-200 dark:from-amber-900 dark:via-amber-800 dark:to-amber-700 rounded-lg p-8 shadow-md">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white">Welcome, {employee.fullName}</h1>
        <p className="text-gray-700 dark:text-gray-200 mt-2 font-medium">Hazer Global Employee Dashboard Portal</p>
      </div>

      {/* Rejection Message Container */}
      <div className="max-w-2xl mx-auto">
        <div className="relative">
          {/* Animated border background */}
          <div className="absolute inset-0 rounded-xl animated-border-glow opacity-100" />

          {/* Main content */}
          <div className="relative bg-white dark:bg-slate-800 rounded-xl shadow-lg border-2 border-transparent p-8">
            {/* Icon */}
            <div className="flex justify-center mb-6">
              <div className="p-4 bg-red-100 dark:bg-red-900/30 rounded-full">
                <XCircle className="w-8 h-8 text-red-600 dark:text-red-400" />
              </div>
            </div>

            {/* Main Message */}
            <div className="text-center mb-8">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">Application Status</h2>
              <p className="text-lg text-gray-700 dark:text-gray-300 leading-relaxed">
               Thank you for your interest in the position and for taking the time to apply.
                At this stage, we have decided to move forward with other candidates.
                However, we are placing your application on our waiting list for future consideration.
              </p>
            </div>

            {/* Divider */}
            <div className="border-t border-gray-200 dark:border-slate-700 my-8" />
          </div>
        </div>
      </div>
    </div>
  )
}
export default RejectedDashboard
